import { FloatingPromptInput } from "./floating-prompt-input.js";
const openFloatingPromptInput = ({
  nodeId,
  editor,
  modals
}) => {
  const { view } = editor;
  const rootLevelNodePosition = view.state.selection.$from.before(1);
  const nodeDOM = view.nodeDOM(rootLevelNodePosition);
  const referenceElement = nodeDOM instanceof Element ? nodeDOM : view.dom;
  modals.openModal({
    id: "FLOATING-PROMPT-INPUT",
    Component: FloatingPromptInput,
    componentProps: { nodeId },
    type: "exclusive",
    layout: "manual",
    positioning: {
      placement: "bottom",
      referenceElement: {
        getBoundingClientRect: () => referenceElement.getBoundingClientRect(),
        focus: () => view.focus()
      }
    },
    returnFocusToEditor: true
  });
};
export {
  openFloatingPromptInput
};
//# sourceMappingURL=open-floating-prompt-input.js.map
